<ng-container *transloco="let t; prefix: 'tasks.taskDetail.approvalFlow'">
  <div class="result-sheet">
    <div class="result-sheet-handle" aria-hidden="true"></div>

    <div class="result-content">
      <div
        class="result-icon"
        [class.result-icon-approved]="data.isApproved"
        [class.result-icon-rejected]="!data.isApproved"
        aria-hidden="true">
        <i
          class="fa-solid"
          [class.fa-circle-check]="data.isApproved"
          [class.fa-circle-xmark]="!data.isApproved"></i>
      </div>

      <span
        class="result-message title-medium-emphasized"
        [class.result-message-rejected]="!data.isApproved">
        {{ t(data.isApproved ? 'approvedResult' : 'rejectedResult') }}
      </span>

      <button matButton="filled" type="button" class="return-button" (click)="returnToList()">
        {{ t('returnToList') }}
      </button>
    </div>
  </div>
</ng-container>
